export const enum ENV {
  Dev = 'dev',
  Qa = 'qa',
  Uat = 'uat',
  Prod = 'prod',
}
